namespace advisorop.domains {
    export interface IMeetingDateRange {
        fromDate: Date;
        toDate: Date;

        updateFromDate(): boolean;
        updateToDate(): boolean;
    }

    export class MeetingDateRange implements IMeetingDateRange {
        fromDate: Date;
        toDate: Date;

        constructor() {
            var now = new Date();
            this.fromDate = new Date(now.getFullYear(), now.getMonth(), 1);
            this.toDate = new Date(this.fromDate);
            this.updateToDate();
        }

        updateFromDate(): boolean {
            var ret = false;
            if (this.fromDate >= this.toDate) {
                this.fromDate = new Date(this.toDate);
                this.fromDate.setMonth(this.toDate.getMonth() - 1);
                ret = true;
            }
            return ret;
        }

        updateToDate(): boolean {
            var ret = false;
            if (this.fromDate >= this.toDate) {
                this.toDate = new Date(this.fromDate);
                this.toDate.setMonth(this.toDate.getMonth() + 1);
                ret = true;
            }
            return ret;
        }
    }
}
